import React from 'react';
import FormModal from '../../shared/components/custom/FormModal';
import ExternalLinkWebsiteComponentForm from './ExternalLinkWebisteComponentForm';
import t from '../../util/translation/translation';

const ExternalLinkWebsiteComponent = ({
  showModal,
  onClose,
  selectedComponent,
  onSave,
}) => {
  if (selectedComponent?.id !== 'specific-external-link') {
    return null;
  }

  const handleSubmit = (values) => {
    const payload = {
      ...selectedComponent,
      value: values.link,
      label: values.label,
    };
    onSave(payload);
  };
  return (
    <FormModal
      isOpen={!!showModal}
      onClose={onClose}
      title={t(`appLayout.externalLink`)}
      subtitle={t('appLayout.modalHintExternalLink')}
    >
      <ExternalLinkWebsiteComponentForm
        component={selectedComponent}
        onSubmit={handleSubmit}
        onClose={onClose}
      />
    </FormModal>
  );
};
export default ExternalLinkWebsiteComponent;
